import React from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "@hookform/error-message";

import { checkMinLength, checkMaxLength } from "../../../services/validation";

import "./inputFields.scss";

function InputFields({
  errors,
  register,
  fieldName,
  disabled,
  requireMark,
  inputType,
  lableName,
  required,
}) {
  return (
    <>
      <label className="inputLabel">
        {lableName}
        {requireMark && <span className="requireMark">*</span>}
      </label>
      {inputType === "inputName" && (
        <div className="inputContainer">
          <input
            {...register(fieldName, {
              required,
              validate: {
                checkMinLenght: (str) => checkMinLength(str),
                checkMaxLenght: (str) => checkMaxLength(str),
              },
            })}
            type="text"
            disabled={disabled}
            className={`formInput ${errors[fieldName] ? "errorField" : ""}`}
          />
          {errors[fieldName] && <div className="errorIcon hasIcon--alert-circle"></div>}
        </div>
      )}
      {inputType === "textArea" && (
        <div className="inputContainer">
          <textarea
            {...register(fieldName, {
              required,
              validate: {
                checkMinLenght: (str) => checkMinLength(str),
              },
            })}
            type="text"
            disabled={disabled}
            className={`formTextArea ${errors[fieldName] ? "errorField" : ""}`}
          />
          {errors[fieldName] && <div className="errorIcon hasIcon--alert-circle"></div>}
        </div>
      )}
      <ErrorMessage
        errors={errors}
        name={fieldName}
        render={({ messages }) =>
          messages &&
          Object.entries(messages).map(([type, message]) => (
            <p className="validationError" key={type}>
              {message}
            </p>
          ))
        }
      />
    </>
  );
}

InputFields.propTypes = {
  inputType: PropTypes.oneOf(["inputName", "textArea"]),
  errors: PropTypes.object,
  register: PropTypes.func,
  fieldName: PropTypes.string,
  disabled: PropTypes.bool,
  requireMark: PropTypes.bool,
  lableName: PropTypes.string,
  required: PropTypes.string,
};

InputFields.defaultProps = {
  errors: "",
  register: "",
  fieldName: "",
  disabled: false,
  requireMark: true,
  inputType: "",
  lableName: "Label",
  required: "This field can't be empty.",
};

export default InputFields;
